export function shouldShowIdentityTooltip({
	visibleText,
	detail,
}: {
	visibleText?: string | null
	detail?: string | null
}): boolean {
	if (!detail) return false
	const visible = visibleText?.trim().toLowerCase()
	return !visible || visible !== detail.trim().toLowerCase()
}
